import { notification } from 'antd'

import { FileEntityType, fileService } from 'services/FileService'
import { ConvertedFile } from 'utils/helpers/files/fileUpload'
import { FileUploadDTO } from 'shared/types/types'

export const useSendTaxFile = () => {
  const trySendTaxFile = async (fileUpload: ConvertedFile, userId: number): Promise<FileUploadDTO | undefined> => {
    try {
      const file = await fileService.fileUpload({
        entityId: userId,
        totalSize: fileUpload.fileSize,
        content: fileUpload.content,
        entityType: FileEntityType.user,
      })

      if (!file) {
        throw new Error('Не удалось загрузить документ подтверждающий НДС')
      }

      if (!file?.imageUrl) {
        throw new Error('Не удалось загрузить документ подтверждающий НДС')
      }

      notification.success({
        message: 'Документ подтверждающий НДС загружен!',
      })

      return file
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: (error as Error).message,
      })
      return
    }
  }

  return trySendTaxFile
}
